import { useState } from 'react'
import { Plus } from 'lucide-react'
import { useTranslation } from '@kostbar/i18n'
import { EdgesTable } from '../components/edges-table'
import { PairingCodeModal } from '../components/pairing-code-modal'
import { RegisterEdgeModal } from '../components/register-edge-modal'
import { ManualProvisionModal } from '../components/manual-provision-modal'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { usePermissions } from '@/shared/hooks/use-permissions'
import { ACTIONS } from '@/shared/constants/actions'
import { PermissionGate } from '@/shared/components/permission-gate'

export function EdgesPage() {
  const { t: tEdges } = useTranslation('edges')
  const [isPairingModalOpen, setIsPairingModalOpen] = useState(false)
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false)
  const [isManualModalOpen, setIsManualModalOpen] = useState(false)
  const { can } = usePermissions()

  return (
    <PermissionGate action={ACTIONS.EDGE_VIEW}>
      <div>
        <div className="mb-6 flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold">{tEdges('title')}</h1>
            <p className="text-muted-foreground mt-2">{tEdges('subtitle')}</p>
          </div>
          <div className="flex gap-2">
            {can(ACTIONS.EDGE_PAIRING_CREATE) && (
              <Button onClick={() => setIsPairingModalOpen(true)}>
                <Plus className="w-4 h-4 mr-2" />
                {tEdges('actions.createPairingCode')}
              </Button>
            )}
            {can(ACTIONS.EDGE_PAIRING_CREATE) && (
              <Button
                variant="outline"
                onClick={() => setIsRegisterModalOpen(true)}
              >
                {tEdges('actions.registerEdge')}
              </Button>
            )}
            {can(ACTIONS.EDGE_PAIRING_CREATE) && (
              <Button
                variant="outline"
                onClick={() => setIsManualModalOpen(true)}
              >
                {tEdges('actions.manualProvision')}
              </Button>
            )}
          </div>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>{tEdges('sections.registered')}</CardTitle>
          </CardHeader>
          <CardContent>
            <EdgesTable />
          </CardContent>
        </Card>

        <PairingCodeModal
          open={isPairingModalOpen}
          onClose={() => setIsPairingModalOpen(false)}
        />
        <RegisterEdgeModal
          open={isRegisterModalOpen}
          onClose={() => setIsRegisterModalOpen(false)}
        />
        <ManualProvisionModal
          open={isManualModalOpen}
          onClose={() => setIsManualModalOpen(false)}
        />
      </div>
    </PermissionGate>
  )
}
